import type { ReactNode } from 'react'
import HourglassEmptyRoundedIcon from '@mui/icons-material/HourglassEmptyRounded'
import { StatusChip } from './Chip'
import { useNls } from '../../nls/nlsProvider'
import './settingsKit.css'

export interface SettingsComingSoonProps {
  icon?: ReactNode
  title: ReactNode
  body: ReactNode
  bullets?: ReactNode[]
  badge?: ReactNode
  className?: string
  testId?: string
}

/**
 * SettingsComingSoon (SR4, §3.3)
 * Polished coming-soon surface for placeholder tabs and sections.
 * Features an icon, title, calm one-sentence body, up to 3 bullets, and a Chip.
 */
export function SettingsComingSoon({
  icon,
  title,
  body,
  bullets,
  badge,
  className,
  testId,
}: SettingsComingSoonProps) {
  const { t } = useNls()

  return (
    <div
      className={['skComingSoon', className].filter(Boolean).join(' ')}
      data-testid={testId}
    >
      <div className="skComingSoon__header">
        <span className="skComingSoon__icon" aria-hidden="true">
          {icon ?? <HourglassEmptyRoundedIcon fontSize="inherit" />}
        </span>
        <h2 className="skComingSoon__title">{title}</h2>
        {badge ?? (
          <StatusChip tone="neutral" size="sm">
            {t('NLSSettingsKitComingSoon')}
          </StatusChip>
        )}
      </div>

      <p className="skComingSoon__body">{body}</p>

      {bullets && bullets.length > 0 ? (
        <ul className="skComingSoon__bullets">
          {bullets.slice(0, 3).map((bullet, idx) => (
            <li key={idx}>{bullet}</li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
